var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiSwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.91,12.93c-1.36,0-2.47-1.11-2.47-2.47s1.11-2.47,2.47-2.47s2.47,1.11,2.47,2.47S9.27,12.93,7.91,12.93z  M7.91,8.48c-1.09,0-1.97,0.89-1.97,1.97s0.89,1.97,1.97,1.97s1.97-0.89,1.97-1.97S9,8.48,7.91,8.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.55,8.87 9.11,8.63 12.17,2.99 14.75,4.26 14.53,4.71 12.38,3.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.5,8.85 3.59,3.67 1.47,4.77 1.24,4.32 3.79,3.01 6.94,8.6  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSwitch);
export default __webpack_public_path__ + "static/media/Multi-Switch.3604bea3973909f86ee87bcbe169d8d0.svg";
export { ForwardRef as ReactComponent };